<template>
    <transition
        enter-active-class="transition ease-out duration-400"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-out duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            class="fixed top-0 left-0 z-[98] flex h-full w-full items-center justify-center bg-gray-500 bg-opacity-30"
        >
            <LoadingSpinner class="text-3xl text-white" />
        </div>
    </transition>
</template>

<script setup lang="ts">
import { LoadingSpinner } from '@src/components'
</script>

<style scoped></style>
